import { defineStore } from 'pinia'
import { ref } from 'vue'

import { useApiClient } from '@/api'
import dayjs from '@/dayjs'
import type { MyStay, PatientSurveyList } from '@/generated/api'

export const useHomeStore = defineStore('home', () => {
  const apiClient = useApiClient()
  const myStay = ref<MyStay | null>(null)
  async function getMyStay(force = false) {
    if (force || !myStay.value) {
      myStay.value = await apiClient.dashboard.dashboardMyStayRetrieve()
    }
    return myStay.value
  }

  async function getHomeAppointments() {
    const { results } = await apiClient.appointments.appointmentsList({
      limit: 3,
      ordering: 'start',
      startGte: dayjs().format(),
    })
    return results || []
  }

  async function getHomeNews() {
    const { results } = await apiClient.news.newsArticlesList({
      limit: 3,
      ordering: 'is_read,-published_date',
    })
    return results || []
  }

  async function getHomeInfo() {
    const { results } = await apiClient.info.infoArticlesList({
      limit: 3,
      ordering: '?',
    })
    return results || []
  }

  async function getOverviewSurveys(patientId: number): Promise<PatientSurveyList[]> {
    return apiClient.dashboard.dashboardSurveysList({
      patientId,
    })
  }

  async function getHomeSurveys(): Promise<PatientSurveyList[]> {
    return apiClient.dashboard.dashboardSurveysList({})
  }

  async function getHomeAbsence(patientId?: number) {
    return apiClient.absence.absenceRetrieve({ patientId })
  }

  return {
    getMyStay,
    getHomeAppointments,
    getHomeNews,
    getHomeInfo,
    getHomeSurveys,
    getHomeAbsence,
    getOverviewSurveys,
    myStay,
  }
})
